import { render, staticRenderFns } from "./MediaDetails.vue?vue&type=template&id=2d45b8b7&scoped=true"
import script from "./MediaDetails.vue?vue&type=script&lang=js"
export * from "./MediaDetails.vue?vue&type=script&lang=js"
import style0 from "./MediaDetails.vue?vue&type=style&index=0&id=2d45b8b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45b8b7",
  null
  
)

export default component.exports